import React from "react";

export const TaskCntx = React.createContext();
export const NotificationCntx = React.createContext();